import { Reply } from 'lucide-react';
import Avatar from './Avatar';
import Button from './Button';
import { formatTimecode } from './Timecode';
import { cx } from './util';

// §2.6 Comment card: number · avatar · name · date · timecode chip · text · Reply. The chip (and the card)
// seeks the player on click; an active card carries the accent outline.
// HD-8: editor replaces the text while it is being edited; actions sit in the foot after Reply (edit, delete,
// resolve); children run under the card body (a reply thread, a reply field). Other props go to the <article>.
export default function CommentCard({ index, author, date, at, text, active = false, resolved = false, onSeek, onReply, format = 'mss', fps, editor, actions, children, ...rest }) {
  const when = date ? new Date(date).toLocaleDateString('en-US', { month: 'short', day: 'numeric' }) : null;
  return (
    <article className={cx('ui ui-cc', active && 'ui-cc--active', resolved && 'ui-cc--resolved')} aria-current={active || undefined} {...rest}>
      <div className="ui-cc__num"><span className="ui-cc__n">{index}</span><Avatar name={author?.name} initials={author?.initials} /></div>
      <header className="ui-cc__head">
        <span className="ui-cc__name">{author?.name || 'Guest'}</span>
        {when && <span className="ui-meta">{when}</span>}
        {at != null && <button type="button" className="ui-cc__chip" onClick={() => onSeek?.(at)} aria-label={`Seek to ${formatTimecode(at, format, fps)}`}>{formatTimecode(at, format, fps)}</button>}
      </header>
      {editor || <p className="ui-cc__text">{text}</p>}
      {(onReply || actions) && !editor && (
        <div className="ui-cc__foot">{onReply && <Button variant="quiet" icon={Reply} onClick={onReply}>Reply</Button>}{actions}</div>
      )}
      {children && <div className="ui-cc__more">{children}</div>}
    </article>
  );
}
